import { Slide } from 'components/UI/V2/Carousel/Slide';

const IMAGE_VIDEO = 'images/sliders/placeholder-video.png';

export const productSlides: Slide[] = [
    {
        id: 1,
        stepNumber: 1,
        title: 'Add your retail products.',
        description:
            '<p>Quickly add products by looking them up by name or barcode—our system will pull in pictures and descriptions for you.</p> <p>Alternatively, you can always manually upload images and edit the product details.</p>',
        image: 'images/sliders/product/slider-product-1.jpg'
    },
    {
        id: 2,
        stepNumber: 2,
        title: 'Price your product.',
        description: `<Box>Set a price for your product and decide whether it can be purchased. </Box>
            <Box style="margin-top: 15px; border: 2px solid #BCB8AE; padding: 10px 15px; display: flex; border-radius: 12px;">
                <svg style="margin-top: 5px; display: flex; align-items: center; justify-content: center; width: 40px; height: 20px; font-size: 14px; font-weight: 500;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="40"><path fill='#BAA997' d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
                <Box style="font-size: 14px; color: #333; padding-left: 10px;">
                    Don’t forget to add any applicable taxes, which you can always update in <strong>Settings > Taxes</strong>.
                </Box>
            </Box>`,
        marginRightDescription: '40px',
        image: 'images/sliders/product/slider-product-2.jpg'
    }
];
